import { IBranch } from "@/api/AppApi/services/company/interfaces/ICompany";
import { Col, Row } from "@/app/components/lib/my-bootstrap";
import { translationResources } from "@/hooks/localization/getTranslation";
import { useTranslation } from "@/hooks/localization/useTranslations";
import generateGoogleMapsLink from "@/utils/helpers/generateGoogleMapsLink";
import SvgBranchAddress from "./branch-icons/SvgBranchAddress";
import SvgBranchBackArrow from "./branch-icons/SvgBranchBackArrow";
import SvgBranchPhone from "./branch-icons/SvgBranchPhone";
import SvgBranchWorktime from "./branch-icons/SvgBranchWorktime";

interface Props {
  branch: IBranch;
  isCheckout?: boolean;
  onCloseInPopuUp?: () => void;
}

const BranchDetails: React.FC<Props> = ({
  branch,
  isCheckout = false,
  onCloseInPopuUp,
}) => {
  const t = useTranslation();
  return (
    <div
      className={`${
        isCheckout ? "checkout-branch-details" : "order-details-branch"
      }`}
    >
      <div
        className="name"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 10,
        }}
      >
        {onCloseInPopuUp ? (
          <SvgBranchBackArrow onCloseInPopuUp={onCloseInPopuUp} />
        ) : (
          <></>
        )}
        {branch?.local_name}
      </div>
      <Row className="m-0 d-flex" style={{ gap: 8 }}>
        <Col className="p-0 col-auto">
          <SvgBranchAddress />
        </Col>
        <Col className="p-0 address">
          {branch?.local_address ?? "no address"}
        </Col>
        {branch?.map_location?.lat && (
          <a
            target="_blank"
            href={generateGoogleMapsLink(branch.map_location)}
            className="p-0 map-link"
          >
            {t.open_maps}
          </a>
        )}
      </Row>
      <Row className="m-0 d-flex" style={{ gap: 8 }}>
        <Col className="p-0 col-auto">
          <SvgBranchPhone />
        </Col>
        <Col className="p-0 col-auto">{t.phone}</Col>
        <Col className="p-0 phone">{branch?.mobile}</Col>
      </Row>
      <div>
        <Row className="m-0 d-flex" style={{ gap: 8 }}>
          <Col className="p-0 col-auto">
            <SvgBranchWorktime />
          </Col>
          <Col className="p-0">{t.worktime}</Col>
        </Row>
        <ul className="d-flex worktime">
          {branch?.working_hours?.map((wh, key) => (
            <li className="p-0 col-auto" key={key}>{`${
              t?.[wh.day_of_week as keyof (typeof translationResources)["ar"]]
            }: ${wh.periods
              .map((p) => `${p.open_at} - ${p.closes_at}`)
              .join(", ")}`}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BranchDetails;
